import React, {useEffect, useState} from 'react';
import './index.scss'
import Header from "../../components/header";
import Game from "../../components/Game";
import Modal from "../../components/Modal";
import {useParams} from "react-router-dom";
import {mapPoint} from "../../components/utils/pointMaps";
import {buttonEnd, textEnd} from "../../components/utils/textEndlevel";

import cup from '../../img/levelPassed/cup.svg'
import compass from '../../img/levelPassed/compass.svg'
import sneakers from '../../img/levelPassed/sneakers.svg'
import heard from '../../img/levelPassed/heard.svg'
import airplane from '../../img/levelPassed/airplane.svg'
import megaphone from '../../img/levelPassed/megaphone.svg'
import ScrollToTop from "../../components/utils/ScrollToTop";
import useWindowSize from "../../components/utils/useWindowSize";

interface Point {
    id: number;
    x: number;
    y: number;
}
const GamePage = () => {
    const { id } = useParams();
    const [openModal, setOpenModal] = useState(false)
    const [levelEnd, setLevelEnd] = useState(false)
    const {height , width} = useWindowSize()

    const textBodyEnd  = textEnd[Number(id) - 1 ]
    const textButtonEnd  = buttonEnd[Number(id) - 1 ]

    useEffect(()=>{
        if(!levelEnd){
            setOpenModal(false)
        }
    },[levelEnd])
    const mapImg =[cup, compass, sneakers, heard, airplane, megaphone]



    ScrollToTop()
    window.addEventListener('resize', () => {
        // получаем текущее значение высоты
        let vh = window.innerHeight * 0.01;
        let vw = window.innerWidth * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        document.documentElement.style.setProperty('--vw', `${vw}px`);
    });

    return (
        <div className={'GameContainer'} style={{maxHeight: height +'px', maxWidth:width + 'px'}}>
            <Header/>
            <Game Img={mapImg[Number(id) - 1]} id={id} setModalOpen={setOpenModal} levelEnd={levelEnd} setLevelEnd={setLevelEnd} />
            <Modal setLevelEnd={setLevelEnd} openModal={openModal} textBodyEnd={textBodyEnd} finalPage={ !!buttonEnd[Number(id)]} buttonEnd={textButtonEnd} id={id}/>
        </div>
    );
};

export default GamePage;
